import DigitInput from './digit-input.vue'
export type { DigitInputProps } from './props'
export default DigitInput